/** Time formatting for timers, history and banners. */

/** mm:ss for a countdown (ceil to whole seconds so "0:00" means truly out of time). */
export function formatClock(ms: number): string {
  const total = Math.max(0, Math.ceil(ms / 1000));
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${m}:${String(s).padStart(2, '0')}`;
}

/** Elapsed time, floored: "0:07", "3:25", "1:02:03" past an hour. */
export function formatElapsed(ms: number): string {
  const total = Math.max(0, Math.floor(ms / 1000));
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  const ss = String(s).padStart(2, '0');
  return h > 0 ? `${h}:${String(m).padStart(2, '0')}:${ss}` : `${m}:${ss}`;
}

/** Whole seconds remaining (ceil), never negative. */
export function secondsLeft(ms: number): number {
  return Math.max(0, Math.ceil(ms / 1000));
}

/** Human setting label: null → "Untimed", 60 → "1 min per turn". */
export function turnTimeLabel(sec: number | null): string {
  if (sec == null) return 'Untimed';
  if (sec % 60 === 0) return `${sec / 60} min per turn`;
  return `${sec} s per turn`;
}

/** "just now", "5 min ago", "2 h ago", "3 d ago". */
export function relativeTime(then: number, now: number): string {
  const diff = Math.max(0, now - then);
  const min = Math.floor(diff / 60_000);
  if (min < 1) return 'just now';
  if (min < 60) return `${min} min ago`;
  const h = Math.floor(min / 60);
  if (h < 24) return `${h} h ago`;
  return `${Math.floor(h / 24)} d ago`;
}
